module.exports = __webpack_public_path__ + "static/media/logo-turiacu.36c9d86c.png";